export default __webpack_public_path__ + "static/media/FAC2.8721dc31.webp";